/* 配置错误处理 */

/*
 例子:
 {
     errcode: 'NO LOGIN',                         //错误代码
     prompt: '你还没有登录或登录超时,请登录...',      //错误提示,空字符为不提示
     url: '/login'                               //跳转地址,true为刷新当前页,空字符串为不跳转
     fun: function () {                          //操作方法,空字符串为无

     }
 }
 */

let is_init = true;
export default {
    data: [
        {
            errcode: 'AUTHORIZATION_INVALID',
            //prompt: '会话已过期,请重新登录',
            url: true,
            fun: function () {
                var that = this;

                /* 避免多次执行 */
                if(!is_init){
                    return false;
                }
                
                is_init = false;

                if(tools.url.params('token') && /(^\/distribution\/(chat))/i.test(location.href)){
                    next();
                }
                // tools.cache.set('Authorization', '');
                localStorage.Authorization = '';
                tools.cache.set('isLogin', 0);
                tools.ajax({
                    url: '/api/init',
                    ajaxData: {},
                    successFun: function (response) {
                        // log.debug('获取到签名:', response);
                        tools.cache.set('Authorization', response.token);
                        // localStorage.Authorization = response.token;
                        tools.cache.set('isAuth', 0);
                        is_init = true;
                        // next();
                        // var globalUrl = location.pathname + location.search;
                        //重新check                        
                        // debugger
                        // next();
                        // tools.loginStatus.checkLogin({
                        //     type: 'login',                   // wechatOauth, login
                        //     // redirectUrl: '/api/wechat/auth',       //验证不通过跳转的地址
                        //     redirectUrl: '/login',       //验证不通过跳转的地址
                        //     url: tools.router.currentRoute.path,   //需要验证的地址
                        //     callbackUrl: globalUrl   //返回的地址
                        // });
                        //window.canauthinit = 1;
                    },
                    errorFun: function (error) {
                        log.error('获取签名失败');
                        // window.canauthinit = 1;
                    },
                    type: 'GET'
                });


                // setTimeout(function () {

                //     if(tools.router.currentRoute.path == '/login'){
                //         tools.loginStatus.check({
                //             type: 'login'
                //         });
                //     }else{
                //         var __url = '';
                //         if(location.href.indexOf('?') != '-1'){
                //             __url = location.href.substring(location.href.indexOf('?'));
                //         }
                //         var url = tools.router.currentRoute.path + __url;
                //         tools.router.replace({path: '/login', query: {callback: encodeURIComponent(url)}});
                //     }

                // }, 0);

            }
        },
        {
            errcode: 'NO LOGIN',
            //prompt: '你还没有登录或登录超时,请登录...',
            url: true,
            fun: function () {
                /* 避免多次执行 */
                if(!is_init){
                    return false;
                }
                
                is_init = false;

                //更改本地登录状态
                window.tools.cache.set('isLogin',0);
                window.tools.cache.set('isAuth',0);
                
                window.tools.cache.set('isUser', '');
                window.tools.cache.set('username', '');
                window.tools.cache.set('userId', '');
                window.tools.cache.set('isDealer', '');
                localStorage.isDealer = '';
                window.tools.cache.set('isPerfect', '');
                window.tools.cache.set('parent', '');
                window.tools.cache.set('loginState', '');
                window.tools.cache.set('is_wechat_login', '');
                // window.tools.cache.set('Authorization', '');
                window.tools.cache.set('level', '');
                localStorage.Authorization = '';
                // debugger
                var __url = '';
                if(location.href.indexOf('?') != '-1'){
                    __url = location.href.substring(location.href.indexOf('?'));
                }
                var url = tools.router.currentRoute.path + __url;
                console.log('err', url);
                // tools.router.replace({path: '/login', query: {callback: encodeURIComponent(url)}});
                //重新check                        
                tools.loginStatus.checkLogin({
                    type: 'login',                   // wechatOauth, login
                    // redirectUrl: '/api/wechat/auth',       //验证不通过跳转的地址
                    redirectUrl: '/login',       //验证不通过跳转的地址
                    url: tools.router.currentRoute.path,   //需要验证的地址
                    callbackUrl: url   //返回的地址
                });
                //window
            }
        }
    ]

}



// WEBPACK FOOTER //
// ./src/error_handle.js